import React from "react"
import { Palette, useTheme } from "@mui/material"
import { BrowserCardLabel } from "src/components/browser/card/BrowserCardLabel"
import { MultilangJob } from "src/services/api/document"

const jobTypeLabelTextColor = (multilangJob: MultilangJob, palette: Palette) => {
  if (multilangJob.status === "QUOTING" || multilangJob.status === "QUOTED") {
    return palette.primary.contrastText
  }
  if (multilangJob.pricingType === "FIXED_ASSET_BASED" || multilangJob.pricingType === "FIXED") {
    return palette.midnightBlue.contrastText
  }
  return palette.primary.contrastText
}

const jobTypeLabelBackgroundColor = (multilangJob: MultilangJob, palette: Palette) => {
  if (multilangJob.status === "QUOTING" || multilangJob.status === "QUOTED") {
    return (palette.lightGold as any)[200]
  }
  if (multilangJob.pricingType === "FIXED_ASSET_BASED" || multilangJob.pricingType === "FIXED") {
    return palette.midnightBlue.main
  }
  if (multilangJob.status === "FINISHED") {
    return (palette.electricMint as any)[200]
  }
  return (palette.primary as any)[200]
}

interface FileCardLabelProps {
  job: MultilangJob
}

export const FileCardLabel: React.FC<FileCardLabelProps> = ({ job }) => {
  const { palette } = useTheme()
  return (
    <BrowserCardLabel
      label={job.tabletName}
      labelBackgroundColor={jobTypeLabelBackgroundColor(job, palette)}
      labelTextColor={jobTypeLabelTextColor(job, palette)}
    />
  )
}
